// extracted by mini-css-extract-plugin
export default {"Component":"ColumnChartWrapper_Component__EJs2H","Carousel":"ColumnChartWrapper_Carousel__q643M"};